/**
 * Store: Main Collection
 * -----------------------------------------------------------------------------
 * Main collection state and events.
 * - Only JSDOC custom parameters, ignore module state or object.
 *
 */
export default {
  namespaced: true,

  state: () => ({
    choices: '',
    filter: [],
    groupedChoices: {},
  }),

  getters: {

    /**
     * Gets user choices.
     * @returns {String}
     */
    getChoices(state) {
      return state.choices
    },

    /**
     * Gets available filters.
     * @returns {Object}
     */
    getFilters(state) {
      return state.filter
    },

  },

  mutations: {

    /**
     * Updates choices state.
     * @param {String} choices - User choices.
     */
    updateChoices(state, choices) {
      state.choices = choices
    },

    /**
     * Updates filters state.
     * @param {Object} filter - Filters response from Nosto.
     */
    updateFilters(state, filter) {
      state.filter = filter
    },

    /**
     * Updates grouped choices state.
     * @param {Object} groupedChoices - Grouped choices response from Nosto.
     */
    updateGroupedChoices(state, groupedChoices) {
      state.groupedChoices = groupedChoices
    },
  },

  actions: {

    /**
     * Actions choices update.
     * @param {String} choices - User choices.
     */
    updateChoices({ commit }, choices) {
      commit('updateChoices', choices)
    },

    /**
     * Actions filters update.
     * @param {Object} filter - Filters response from Nosto.
     */
    updateFilters({ commit }, filter) {
      commit('updateFilters', filter)
    },

    /**
     * Actions grouped choices update.
     * @param {Object} groupedChoices - Grouped choices response from Nosto.
     */
    updateGroupedChoices({ commit }, groupedChoices) {
      commit('updateGroupedChoices', groupedChoices)
    },

    /**
     * Process and group choices by filter type
     * @param {Object} context - Vuex context
     * @param {String} choices - Raw choices string
     */
    processGroupedChoices({ commit, state, dispatch }, choices) {
      dispatch('updateChoices', choices)

      if (!choices) {
        commit('updateGroupedChoices', {})
        return
      }

      const filters = state.filter
      const choicesArray = choices.split('&').filter(choice => choice !== '' && !choice.includes('page='))
      const groupedChoices = {}

      choicesArray.forEach(choice => {
        if (!choice) {
          return
        }

        const [key, value] = choice.split('=')
        const decodedKey = decodeURIComponent(key.replace(/^&/, ''))
        const decodedValue = decodeURIComponent(value || '')
        let groupName = 'Other'
        let displayValue = decodedValue
        let filterValue

        if (decodedKey === 'sort' || decodedKey === 'sort[]' || decodedKey.startsWith('sort')) {
          groupName = 'Sort'
          displayValue = decodedValue
        } else if (filters && Array.isArray(filters)) {
          for (const filter of filters) {
            const parsedValue = filter.field.replaceAll('.', '__')
            const decodedKeyIncludesParsed = decodedKey.includes(parsedValue)
            const decodedKeyIncludesPfParsed = decodedKey.includes(`pf_${parsedValue}`)

            const ngName = filter.name

            if (
              decodedKeyIncludesParsed ||
              decodedKeyIncludesPfParsed
            ) {
              groupName = ngName

              if (filter.data) {
                filterValue = filter.data.find(item => item.value === decodedValue ||
                  encodeURIComponent(item.value) === value)
                if (filterValue) {
                  displayValue = filterValue.value
                }
              }
              break
            }
          }
        }

        if (!groupedChoices[groupName]) {
          groupedChoices[groupName] = []
        }

        groupedChoices[groupName].push({
          key: decodedKey,
          value: decodedValue,
          displayValue,
          original: choice,
          count: filterValue ? filterValue.count : null,
        })
      })

      commit('updateGroupedChoices', groupedChoices)
    },
  },
}
